module.exports = __webpack_public_path__ + "ab62024a2059e7909845c7843a5f1e9d.woff2";